<template>
    <div
        :class="{
            'c c-5 c-xs2-4 c-sm-4 c-sm2-6 c-md-4 c-lg-5 c-xl-6 keen-slider__slide': carouselCard,
            'c c-12 c-sm-6 c-md-4': !carouselCard,
        }"
        v-if="syndicate"
    >
        <a :href="betHref" class="syndicate__card" @click.prevent="showDetail">
            <div class="syndicate__card__detail">
                <div class="info">
                    <div class="info__size">{{ syndicateDefinition.size }}</div>
                    <div class="info__type">{{ syndicateDefinition.lottery }}</div>
                    <div class="info__price">
                        <div class="info__price__amount" v-html="formatCurrency(syndicateDefinition.sharePrice)"></div>
                        <div class="info__price__portion">za 1 podíl</div>
                    </div>
                </div>
                <div
                    class="bg-img"
                    :class="syndicate.lottery.replace('sportkamh', 'sportka')"
                    v-html="syndicateImage"
                ></div>
                <div class="name">
                    <span class="name__name">
                        {{ betName }}
                    </span>
                </div>
            </div>
            <div class="syndicate__card__description">
                <div class="remaining-share">
                    <span>Zbývá {{ syndicate.unsoldParts }} z {{ syndicateTotalPartsLabel }}</span>
                    <FillTrack
                        :lottery="syndicate.lottery"
                        :totalParts="syndicateDefinition.shareCount"
                        :unsoldParts="syndicate.unsoldParts"
                    />
                </div>
                <div class="details">
                    <div class="details__date">
                        <i class="icon-date" />
                        <time>
                            {{ syndicateDrawDateFormatted }}
                        </time>
                    </div>
                    <div class="details__type">
                        <i class="icon-checkbox" />
                        {{ syndicateDefinition.name }}
                    </div>
                </div>
            </div>
        </a>
        <teleport to="body">
            <SyndicateDetail
                :wagerId="syndicate.wagerId"
                v-if="showDetailComponent"
                @closed="showDetailComponent = false"
            />
        </teleport>
    </div>
</template>

<script lang="ts" setup>
import "@/../../css/lotteries/syndicates/syndicates-partials/syndicates-card.scss";
import { computed, ref, watch } from "vue";
import useSyndicateDetails from "@/lotteries/composables/syndicates/use-syndicate-details";
import FillTrack from "./fill-track-detail.vue";
import { SyndicatePreview } from "@/lotteries/model/syndicates/syndicate-preview";
import { StringUtils } from "@sazka/utils/string-utils";
import SyndicateDetail from "@/lotteries/components/syndicates/_syndicate-detail.vue";

const props = defineProps<{
    carouselCard?: boolean;
    data: SyndicatePreview;
}>();

const syndicate = computed(() => props.data);

const showDetailComponent = ref(false);
const showDetail = () => {
    showDetailComponent.value = true;
};

const { syndicateDefinition, syndicateImage, syndicateTotalPartsLabel, syndicateDrawDateFormatted } =
    useSyndicateDetails(syndicate);

const betName = computed(() => {
    const name = syndicate.value.name;

    return name.length > 50 ? name.substring(0, 51) + "..." : name;
});

const betHref = computed(() => {
    return `/s/${syndicate.value.wagerId}`;
});

// history api magic below

// detail was opened first (loading of syn. cards was suppressed) -> push new state when cards are loaded (detail was closed)
if (window.location.href.includes("/loterie/skupinove-sazeni/detail/" + syndicate.value.wagerId)) {
    window.history.pushState(
        { referrer: "/loterie/skupinove-sazeni/detail/" + syndicate.value.wagerId },
        document.title,
        "/loterie/skupinove-sazeni/skupinove-sazky"
    );
}

const preventHistoryPush = ref(false);
watch(showDetailComponent, (showingDetail) => {
    const referrer = window.history.state?.referrer;

    if (preventHistoryPush.value) {
        preventHistoryPush.value = false;
        return;
    }

    const detailUrl = "/loterie/skupinove-sazeni/detail/" + syndicate.value.wagerId;

    window.history.pushState(
        { referrer: window.location.href },
        document.title,
        showingDetail ? detailUrl : referrer ?? detailUrl
    );
});
window.addEventListener("popstate", (event) => {
    if (window.location.href.includes("/detail/" + syndicate.value.wagerId)) {
        if (!window.history.state) {
            // opened direct detail link, closed detail and navigated back in browser (back to detail) edge case
            window.history.replaceState(
                { referrer: "/loterie/skupinove-sazeni/skupinove-sazky" },
                document.title,
                document.location.href
            );
        }
        preventHistoryPush.value = true;
        showDetail();
        // prevent other components with the same ID showing (and overwriting) detail in this component
        event.stopImmediatePropagation();
        event.stopPropagation();
    } else {
        // if detail is opened, watcher would push new state and thus opening detail again (case: detail is opened and you navigate back in browser )
        if (showDetailComponent.value) {
            preventHistoryPush.value = true;
        }
        showDetailComponent.value = false;
    }
});

const { formatCurrency } = StringUtils;
</script>
